<template>
  <div class="manage-wrapper" :class="{'sort-manage': sortState}">
    <w-navbar :icon="'iconchevron-left'" :cvShow="true" :nav_title="'模块管理'" :right_btn_html="sortText"
              @mobileLeftBtn="pageBack" @mobileRightBtn="changeSortState"/>
    <div v-if="!loadingShow">
      <div class="current-module">
        <draggable v-model="moduleSort" :options="{disabled, animation: 200, ghostClass: 'ghost'}">
          <transition-group type="transition" :name="!drag ? 'flip-list' : null">
            <template v-for="(item, index) in moduleSort">
              <div :key="index" class="module-item flex-between"
                   :style="sortState ? 'border-bottom: 1px solid #EEEEEE' : ''">
                <span class="title">{{ item.title }}</span>
                <div class="delete flex-start" v-show="!sortState">
                  <span class="iconfont iconbianji" @click="moduleNameChange(item, index)"/>
                  <span class="iconfont iconshanchujianli" @click="deleteModuleInfo(item, index)"/>
                </div>
                <img class="sort-img" v-show="sortState" src="https://files.wondercv.com/icon/sort.png" alt="">
              </div>
            </template>
          </transition-group>
        </draggable>
      </div>
      <div class="overage-module" v-show="!sortState">
        <p class="overage-title">添加新模块</p>
        <div class="overage-list flex-start">
          <div v-for="(item, index) in overage" :key="index" class="overage-item"
               :class="{'overage-item-reset': item.reset}" @click="addModuleInfo(item, index)">
            <span class="iconfont" :class="item.reset ? 'iconcvs-gengxin' : 'iconplus'"/>
            <span class="overage-name">{{ item.name || item.title }}</span>
						<img src="https://files.wondercv.com/pc-cvs/vip-icon.png" class="vip-icon" v-if="item.hasVip || item.type === 'opus'"/>
          </div>
        </div>
      </div>
    </div>
    <upload :upload-show="logoState" @addSchoolLogo="pageBack" @handleClose="logoState = false"
            :uploadType="'logo'"/>
    <w-loading v-if="loadingShow"/>
    <await-loading :show-text="true" v-if="awaitLoadingShow"/>
    <change-module-name :state="changeNameState" :moduleTitles="moduleTitles" :module-name="sectionInfo.title" :section-info="sectionInfo"
                        @handleClose="changeNameState = false" @refresh="refresh"/>
  </div>
</template>

<script>
	import api from '@/api/api-list'
	import WNavbar from '@/components/global/w-navbar'
	import WLoading from '@/components/global/w-loading'
	import changeModuleName from '../cv-components/change-module-name'
	import upload from '../cv-components/upload'
	import draggable from 'vuedraggable'
	import { mapActions, mapState, mapMutations } from 'vuex'
	import { envMixin, eventMixin } from '@/assets/js/mixin/global'
	import { componentsMixin } from '@/assets/js/mixin/components'

	export default {
		name: 'module',
		mixins: [ componentsMixin, envMixin, eventMixin ],
		data () {
			return {
				rightBtnHtml: '<span>排序</span>',
				loadingShow: true,
				token: '',
				moduleSort: [],
				overage: [],
				sortState: false,
				logoState: false,
				drag: false,
				changeNameState: false,
				sectionInfo: {},
				awaitLoadingShow: false,
				changeNameIndex: 0,
				extrasField: [ 'language', 'skill', 'certificate', 'interest', 'other' ],
        moduleTitles: []
			}
		},
    created () {
		  this.getCvSectionTitle()
    },
		mounted () {
			this._initSort()
			this.iosBridge()
		},
		computed: {
			...mapState('cv', [ 'cv', 'overageModule', 'cvSort', 'section_titles' ]),
			...mapState('user', [ 'userData' ]),
			disabled () {
				return !this.sortState
			},
			sortText () {
				return this.sortState ? '<span style="font-size: 16px;">确定</span>' : '<span style="font-size: 16px;">排序</span>'
			}
		},
		watch: {},
		components: {
			WNavbar,
			WLoading,
			draggable,
			upload,
			changeModuleName,
			awaitLoading: WLoading
		},
		methods: {
			...mapActions('cv',
				[ 'deleteModule',
					'updateCvDetail',
          'getCvSectionTitle'
				]),
			...mapMutations('cv', [ 'changeInfoTitle' ]),
			refresh (name) {
				this.moduleSort[this.changeNameIndex].title = name
			},
			moduleNameChange (item, index) {
        let moduleTitles;
        if (item.type === 'works') {
          if (this.cv.basic_info.lang) {
            moduleTitles = this.section_titles['work'][this.cv.basic_info.lang]
          } else {
            moduleTitles = []
          }
        } else if (item.type === 'edus'){
          if (this.cv.basic_info.lang) {
            moduleTitles = this.section_titles['edu'][this.cv.basic_info.lang]
          } else {
            moduleTitles = []
          }
        }
        this.moduleTitles = moduleTitles
				this.changeNameIndex = index
				this.sectionInfo.title = item.title || ''
				this.sectionInfo.titleInfo = item
				this.changeNameState = true
			},
			async changeSortState () {
				if (this.sortState) {
					this._updateCvContent({
						operation_type: 'update_submodule_info',
						submodule_info: {}
					})
				}
				this.sortState = !this.sortState
			},
			pageBack () {
				this.$router.back()
			},
			// 删除模块事件
			deleteModuleInfo (infos, index) {
				if (!this.sortState) {
					this.dialog = this.$createDialog({
						title: '提示',
						type: 'confirm',
						content: '是否删除该模块?',
						onConfirm: async () => {
							this._deleteModule(infos, index)
						}
					}).show()
				}
			},
			// 添加或者恢复模块的事件
			addModuleInfo (item, index) {
				if (item.reset) {
					this._saveModule(item, index)
				} else {
					if ((item.hasVip || item.type === 'opus') && !this.userData.is_membership) {
						 this.$fn.jump(
								`/pages/member-buy/index`,
								() => {
									this.$router.push(`/buy/member/order`)
								}
							)
							return
					}
					this._addModule(item)
				}
			},
			async _initSort () {
				this.token = this.$route.params.token
				let subModuleInfo = this.cv.submodule_info
				this.moduleSort = subModuleInfo.sections_position.map((item, index) => {
					if (item.id) {
						return { ...item, title: subModuleInfo.custom_sections_titles[`${ item.id }_title`], index, }
					} else if (item.type === 'extras') {
						let info_ids = {}, info_titles = {}
						this.extrasField.forEach((item, i) => {
							info_ids[`${ item }_id`] = subModuleInfo[`${ item }_id`]
							info_titles[`${ item }_title`] = subModuleInfo[`${ item }_title`]
						})
						return { ...item, index, title: subModuleInfo.extras_title, info_ids, info_titles }
					} else {
						return {
							...item,
							index,
							title: subModuleInfo[`${ item.type }_title`],
							info_ids: subModuleInfo[`${ item.type }_ids`]
						}
					}
				})
				this.overage = JSON.parse(JSON.stringify(this.overageModule))
				if (this.overage.findIndex(v => v.type === 'custom') === -1) {
					this.overage.push({
						title: '自定义模块',
						type: 'custom'
					})
				}
				if (!this.cv.basic_info.school_logo_url) {
					this.overage.push({ type: 'schoolLogo', name: '校徽', hasVip: true })
				}
				this.loadingShow = false
			},
			// 删除模块的操作
			async _deleteModule (infos, index) {
				let payload = { operation_type: 'update_submodule_info', submodule_info: {} }
				this.moduleSort.splice(index, 1)

				if(infos.type === 'opus' && infos.info_ids.length){
					let deleteOpus = []
					infos.info_ids.forEach(item=>{
						deleteOpus.push(api.cv.deleteOpus(item))
					})
					//走直接作品接口
					await Promise.all(deleteOpus)
				}
				if (infos.id) {
					payload.submodule_info.custom_sections_ids = this.cv.submodule_info.custom_sections_ids.filter(id => id !== infos.id)
				} else if (infos.type === 'extras') {
					this.extrasField.forEach(item => {
						payload.submodule_info[`${ item }_id`] = null
						payload.submodule_info[`${ item }_title`] = null
					})
				} else {
					payload.submodule_info = { [`${ infos.type }_ids`]: [] }
				}
				await this._updateCvContent(payload)
				if(infos.type !== 'opus'){
					infos.reset = true
				}
				this.overage.unshift(infos)
			},
			// 恢复模块
			async _saveModule (infos, index) {
				let payload = { operation_type: 'update_submodule_info', submodule_info: {} }
				let { submodule_info: { custom_sections_ids } } = this.cv
				this.moduleSort.splice(infos.index, 0, infos)
				if (infos.id) {
					custom_sections_ids.splice(infos.index, 0, infos.id)
					payload.submodule_info.custom_sections_ids = custom_sections_ids
				} else if (infos.type === 'extras') {
					payload.submodule_info = { ...infos.info_ids, ...infos.info_titles }
				} else {
					payload.submodule_info = { [`${ infos.type }_ids`]: infos.info_ids }
				}
				await this._updateCvContent(payload)
				infos.reset = false
				this.overage.splice(index, 1)
			},
			// 添加模块
			async _addModule (item) {
				try {
					let { token } = this.$route.params
					let query = {
						operation: 'createModule'
					}
					if (item.type === 'schoolLogo') {
						this.logoState = true
					} else if (item.type === 'extras') {
						this.$router.push({
							path: `/cvs/${ token }/extras`,
							query
						})
					} else if (item.type === 'edus' || item.type === 'orgs' || item.type === 'works' || item.type === 'opus' ) {
						this.$router.push({
							path: `/cvs/${ token }/${ item.type }/add/edit`,
							query
						})
					} else {
						this.$router.push({
							path: `/cvs/${ token }/create_custom/${ item.type }/add/edit`,
							query
						})
					}
					this.changeInfoTitle(item.title)
				} catch (e) {
					this.awaitLoadingShow = false
					console.log(e)
				}
			},
			// 更新简历内容
			_updateCvContent (payload) {
				let { token } = this.$route.params
				let sort = JSON.parse(JSON.stringify(this.moduleSort))
				sort.forEach((item, i) => {
					delete item.title
					delete item.index
					delete item.reset
					delete item.info_titles
					if (item.type === 'extras') {
						item.info_ids = []
					} else if (item.id) {
					} else {
						item.info_ids = []
					}
				})
				payload.submodule_info.sections_position = sort
				this.updateCvDetail({ token, payload })
			},
			// ios 相关内容
			iosBridge () {
				if (this.isIos) {
					this.registerBridge('confirmOrder', this.changeSortState)
					this.registerBridge('toOrder', this.changeSortState)
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .manage-wrapper {
    padding-top: 44px;
    .current-module {
      padding: 0 24px;
      border-bottom: 12px solid #f9f9f9;
      .module-item {
        width: calc(100vw - 48px);
        padding: 20px 0;
        height: 54px;
        border-bottom: 1px solid #eeeeee;
        box-sizing: border-box;
        &:last-child {
          border: none;
        }
        .title {
          font-size: 14px;
          font-weight: 400;
          color: $color-title;
					@include ellipsis(calc(100vw - 118px));
        }
        .delete {
          color: #c4c4c4;
          height: 54px;
          font-weight: 600;
          .iconfont {
            font-weight: 600;
          }
          .iconbianji {
            margin-right: 24px;
          }
          .iconshanchujianli {
            font-size: 20px;
          }
        }
        .sort-img {
          width: 26px;
          height: 10px;
        }
      }
    }
    .overage-module {
      padding: 24px 0 0 28px;
      .overage-title {
        color: $color-title;
        line-height: 20px;
        margin-bottom: 18px;
      }
      .overage-list {
        flex-wrap: wrap;
        /*justify-content: space-between;*/
        .overage-item {
          padding: 10px 16px;
          background-color: #f9f9f9;
          border-radius: 2px;
          margin-right: 16px;
          margin-bottom: 16px;
          color: #9c9c9c;
					position: relative;
          .iconfont {
            font-weight: bold;
            margin-right: 4px;
          }
          .iconcvs-gengxin {
            color: #4183FF;
            font-size: $font-size-small;
          }
					.vip-icon{
						position: absolute;
						width: 22px;
						top: -4px;
						right: -4px;
					}
          /*&:last-child {*/
          /*  margin-right: 0;*/
          /*}*/
        }
        .overage-item-reset {
          background-color: #F0F5FF;
          color: #4183FF;
        }
      }
    }
  }
  .sort-manage {
    background-color: #f9f9f9;
    .current-module {
      border: none;
      background-color: $color-light;
    }
  }
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: #ececec;
  }
</style>
